import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';
import { DailyResults } from '../models/daily-results';

@Injectable({
  providedIn: 'root',
})
export class ResultsService {
  constructor(private http: HttpClient) {}

  getDailyResults(params?: { since?: string; until?: string }): Observable<DailyResults[]> {
    let httpParams = new HttpParams();

    if (params?.since) {
      httpParams = httpParams.set('since', params.since);
    }

    if (params?.until) {
      httpParams = httpParams.set('until', params.until);
    }

    return this.http.get<DailyResults[]>(
      `${environment.apiUrl}/admin/accounts/results/`,
      { params: httpParams }
    );
  }
}
